export const navMenu = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About",
    path: "/About",
    subMenu: [
      {
        title: "Faqs",
        path: "/Faqs",
      },
      {
        title: "Policies",
        path: "/Policies",
      },
    ],
  },
  {
    title: "Treatments + Rate",
    path: "/Treatments",
  },
  {
    title: "Training",
    path: "/Training",
  },
  {
    title: "Pre-post care",
    subMenu: [
      {
        title: "Eyebrow Tattoo Care",
        path: "/EyebrowTattooCare",
      },
      {
        title: "EyeLiner Tattoo Care",
        path: "/EyeLinerTattooCare",
      },
      {
        title: "Lip Tattoo Care",
        path: "/LipTattooCare",
      },
      {
        title: "Microneedling Care",
        path: "/MicroneedlingCare",
      },
      {
        title: "Rejuvi Tattoo Removal",
        path: "/RejuviTattooRemovalCare",
      },
      {
        title: "Scalp Micropigmentation (SMP)",
        path: "/ScalpMicropigmentationCare",
      },
    ],
  },
  {
    title: "Reviews",
    path: "/Reviews",
  },
  {
    title: "Contact Us",
    path: "/ContactUs",
  },
];
